<template>
	<div class="flex wrap xs-12 xs-right">
		<core-form-input 
      class="xs-12"
      id="remark" 
      name="remark" 
      componentName="j-base-input-long-text" 
      v-model="remark" 
    />
		<j-button class="mt2" size="small" @click="updateRemark">{{$t("update")}}</j-button>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton/"

export default {
	components: { CoreFormInput, JButton },

	props: {
		id: String,
		payload: {
			type: String,
			default: () => {
				return null
			}
		}
	},

	data() {
		return {
			remark: null
		}
	},

	methods: {
		updateRemark() {
			this.$emit("update", {
				benefitClaimId: this.id,
				remark: this.remark
			})
		}
	},

	created() {
		if (this.payload) this.remark = this.payload
	}
}
</script>